import {Component, OnInit} from '@angular/core';
import {ReportService} from '../../../../services/report.service';
import {ActivatedRoute} from '@angular/router';
import {EditableReportListItemDTO} from '../../../../model/editableReportListItemDTO';

@Component({
  templateUrl: './edit-report-list.component.html',
})
export class EditReportListComponent implements OnInit {
  stateEnum = EditableReportListItemDTO.StateEnum;

  reports: EditableReportListItemDTO[];
  clientId: number;

  constructor(private route: ActivatedRoute,
              public service: ReportService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.clientId = params['clientId'];
      this.refresh();
    });
  }

  private refresh() {
    this.service.getEditableList(this.clientId).subscribe(reports => this.reports = reports);
  }

  create(report: EditableReportListItemDTO) {
    this.service.create(this.clientId, report.code, report.year).subscribe(() => this.refresh());
  }

  undoFinished(report: EditableReportListItemDTO) {
    this.service.undoFinished(this.clientId, report.code, report.year).subscribe(() => this.refresh());
  }

  close(report: EditableReportListItemDTO) {
    this.service.close(this.clientId, report.code, report.year).subscribe(() => this.refresh());
  }
}
